// @flow
import "isomorphic-fetch";

import { generateApiUrl } from "./apiEndPoints";
import { setAuthHeader, appUpdateWarnings } from "../helpers";

// import versionConfig from "../../configs/versionConfig";

// eslint-disable-next-line no-console
// console.log("Config {}", config);

// eslint-disable-next-line
export const makeApiCall = (apiCallObj: Object) => {
  const url = generateApiUrl(apiCallObj);
  const apiConfig: Object = {
    method: apiCallObj.method || "GET",
    headers: {},
    mode: "cors",
    cache: "default"
  };
  apiConfig.headers.Authorization = setAuthHeader();
  apiConfig.headers.appname = "ticketing_ui"; // Hard-coded (Ticketing)
  apiConfig.headers.appversion =
    (process.env && process.env.NODE_VERSION) || "1";
  apiConfig.headers.newResponse = "true";

  if (!apiCallObj.postFormData) {
    apiConfig.headers["Content-Type"] =
      apiCallObj.contentType || "application/json";
  } else if (apiCallObj.postFormData) {
    apiConfig.body = apiCallObj.data;
  }
  if (
    apiCallObj.method !== "GET" &&
    apiCallObj.data &&
    !apiCallObj.postFormData
  ) {
    apiConfig.body = JSON.stringify(apiCallObj.data);
  }

  return fetch(url, apiConfig)
    .then(response => {
      if (response.status === 205) {
        // eslint-disable-next-line
        const refreshConfirmed = window.confirm(appUpdateWarnings.message);
        if (refreshConfirmed === true) {
          throw new Error(appUpdateWarnings.refreshRequiredConfirm);
        }
        throw new Error(appUpdateWarnings.refreshRequiredCancel);
      }
      if (response.status >= 400) {
        throw new Error("Bad response from server");
      }
      if (apiCallObj.responseType === "arraybuffer") {
        return response.arrayBuffer();
      }
      return response.json();
    })
    .then(resData => {
      if (resData) {
        // eslint-disable-next-line no-console
        console.log("api success res = ", resData);
        if (apiCallObj.successCb) {
          apiCallObj.successCb(resData);
        }
      } else {
        if (apiCallObj.failureCb) {
          apiCallObj.failureCb();
        }
        // eslint-disable-next-line no-console
        console.log("api fail res= ", resData);
      }
    })
    .catch(e => {
      if (e.message === appUpdateWarnings.refreshRequiredConfirm) {
        window.location.reload(true);
      } else if (e.message === appUpdateWarnings.refreshRequiredCancel) {
        // eslint-disable-next-line
        console.log("refresh cancelled");
      } else if (apiCallObj.catchCb) {
        apiCallObj.catchCb();
      }
      // eslint-disable-next-line no-console
      console.log("api catch err= ", e);
    });
};



// WEBPACK FOOTER //
// ./app/services/apiService/apiService.js